<template>
	<div class="stage stage--introAbquiz" :style="{ 'background-image': backgroundImage }">
		
		<div class="introAbquiz__background-overlay background-overlay">
			
			<div class="content-container">

				<div class="header__container">
					<div class="header" style="position: relative">
						{{questionData.header}}
					</div>
					<div class="subHeader" style="position: relative">{{questionData.subheader}}</div>
					<div class="text" style="position: relative">
						<div class="question-header">{{questionData.questionheader}}</div>
						{{questionData.questiontext}}
					</div>
				</div>

				<div class="btn__explanation" @click="showExplanationPopup">
					<i class="fa fa-question"></i>
				</div>


				<div v-if="questionData != null" class="centered" >

					<div class="card card-valueQuiz" v-if="roundData.questions.abtemplate == 'goatsheep'">

						<div class="image-box">
							<div class="gW-btn-answer gW-answer-text" @click="() => {onQuestionAnswer('1')}">
								
								<img :src="baseUrl + questionData.answers[0].visual"/>
								<p v-html="questionData.answers[0].answer_text"></p>
								
								<div class="overlay">
									<div class="header">Antwoord A</div> 
									<div class="text">
										<p v-html="questionData.answers[0].answer_text"></p>
									</div>
								</div>
							</div>
						</div>
						
						<div class="answer-divider"></div>

						<div class="image-box">
							<div class="gW-btn-answer gW-answer-text" @click="() => {onQuestionAnswer('2')}">
								
								<img :src="baseUrl + questionData.answers[1].visual"/>
								<p v-html="questionData.answers[1].answer_text"></p>
								<div class="overlay">
									<div class="header">Antwoord b</div> 
									<div class="text">
										<p v-html="questionData.answers[1].answer_text"></p>
									</div>
								</div>
							</div>
						</div>

						<div class="image-box">
							<div class="gW-btn-answer"  @click="() => {onQuestionAnswer('1')}">
								<img :src="baseUrl + questionData.answers[0].visual" alt="">
							</div>
						</div>
						<div class="image-box">
							<div class="gW-btn-answer" @click="() => {onQuestionAnswer('2')}">
								<img :src="baseUrl + questionData.answers[1].visual" alt="">
							</div>
						</div>
					</div>


					<div class="card card-valueQuiz" v-else>

						<div class="image-box">
							<div class="shadow-box" @click="() => {onQuestionAnswer('1')}">
								<img :src="baseUrl + questionData.answers[0].visual" alt="">
								<!-- <img :src="baseUrl + questionData.answers[0].visual"/> -->
								<p v-html="questionData.answers[0].answer_text"></p>
								
								<div class="overlay">
									<div class="header">Antwoord A</div> 
									<div class="text">
										<p v-html="questionData.answers[0].answer_text"></p>
									</div>
								</div>
							</div>
						</div>
						
						<div class="answer-divider"></div>

						<div class="image-box">
							<div class="shadow-box" @click="() => {onQuestionAnswer('2')}">
								<img :src="baseUrl + questionData.answers[1].visual" alt="">
								<!-- <img :src="baseUrl + questionData.answers[1].visual"/> -->
								<p v-html="questionData.answers[1].answer_text"></p>
								<div class="overlay">
									<div class="header">Antwoord b</div> 
									<div class="text">
										<p v-html="questionData.answers[1].answer_text"></p>
									</div>
								</div>
							</div>
						</div>

						<div class="image-box">
							<div class="btn-answer"  @click="() => {onQuestionAnswer('1')}">
								A
							</div>
						</div>
						<div class="image-box">
							<div class="btn-answer" @click="() => {onQuestionAnswer('2')}">
								B
							</div>
						</div>
					</div>


				</div>
			</div>
		</div>

		<ExplanationPopup 
			v-if="explanationPopupActive == true" 
			:additionalHTML="additionalHTML"
			:on-click="hideExplanationPopup"/>
		
	</div>
</template>

<script>
	import Score from '../../Score.vue';
	import Button from './Button.vue';
	import { url} from '../../../const/base';
	import { mapGetters , mapActions } from 'vuex';
	import ExplanationPopup from '../ExplanationPopup.vue';

	export default {

		components:{
			Score,
			AnswerButton : Button,
			ExplanationPopup,
		},

		data(){
			return{
				baseUrl : url,
				score: 0,
				answers: [],
				mappedSdgs: [],
				explanationPopupActive: false,
				additionalHTML:"",
			}
		},

		beforeMount(){
			this.buildInfoAddonHTML();
		},


		mounted(){
			this.score = 0;
			this.showTransitorScore(true);
		},

		computed: {

			...mapGetters([
				"lastQuestion",
				"currentBlock",
				"blocks",
				"currentStage",
				"currentRound",
				"currentQuestion",
				"roundCount",
				"stageData",
				"roundCompleted",
				"scores",
				"questionData",
				"stageCount",
				"roundScore",
				"roundData"
			]),

			backgroundImage: function() {
				console.log('bg: '+this.roundData.questions.question_background);
		        return 'url('+ this.baseUrl + this.roundData.questions.question_background + ')';
		    },

			finalScore(){
				let finalScore=0;
				let scores = 0;
				for(let score of this.scores[this.currentBlock][this.currentStage-1]){
					scores++;
					finalScore += score;
				}
				finalScore /= scores;
				return finalScore;
			},
		},


		methods:{

			...mapActions([
				"completeRound",
				"toNextQuestion",
				"setRoundScore",
				"increaseTransitorScore",
                "showTransitorScore",
				"logAnswers",
				"logSdgs",
			]),

			buildInfoAddonHTML(){
				this.additionalHTML = this.roundData.questions.rules;	
			},

			hideExplanationPopup(){
				this.explanationPopupActive = false;
			},

			showExplanationPopup(){
				this.explanationPopupActive = true;
			},

			onQuestionAnswer(e){
				let correctAnswer = +e == this.questionData.correct_answer;
				let questionCount = this.roundData.questions.questions.length;


				this.answers.push(e);

				console.log('answer: '+e);
				console.log('correctAnswer: '+correctAnswer);

				//sdg count
				//store the sdg's mapped to this question
				if(typeof this.questionData.answers[e-1].sdg_mapping !== 'undefined'){
						
					console.log('sdgs mapping:');

					//check if it's a single entry or comma seperated
					let sdgMappingObject = this.questionData.answers[e-1].sdg_mapping.split(",");

					console.log(sdgMappingObject);

					for (var i = 0; i < sdgMappingObject.length; i++) {
						this.mappedSdgs.push(sdgMappingObject[i]);
					};
				}




				if(correctAnswer){
					this.score ++;
					this.increaseTransitorScore(+this.roundData.questions.transitor_multiplier);
				}else{
					//this.score += 0.5
					this.increaseTransitorScore(+this.roundData.questions.transitor_multiplier/2);
				}

				console.log('score: '+this.score);

				if(this.lastQuestion){
					let score = (this.score/questionCount)*100;

					this.setRoundScore(score).then(()=>{
						this.logAnswers(this.answers).then(()=>{
							this.logSdgs(this.mappedSdgs).then(()=>{
								this.completeRound();
							});
						});
					});
				}
				else{
					this.toNextQuestion();
				}
			}
		}

	}
</script>



// WEBPACK FOOTER //
// src/components/minigames/abquiz/Index.vue